@use "../../../scss/settings/colors";

.page_title {
  text-transform: capitalize;
  color: colors.$base-black;
  font-size: 26px;
}

